import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Box, Avatar, Typography, Button, Stack, Paper,
  IconButton, Zoom, Fade, Badge, CardActionArea, TextField
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ChatIcon from "@mui/icons-material/Chat";
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import ReplayIcon from '@mui/icons-material/Replay';
import { useApiMutation } from "../generic/useApi";

export const RESIDENTIAL_TYPES = [
  "1 RK / Studio Apratment", "Flats / Apartments", "Builder Floor",
  "Land / Plot", "Penthouse", "Studio", "Independent House / Villa", "Farmhouse",
];

export const COMMERCIAL_TYPES = [
  "Office", "Warehouse/Godown", "Shop", "Commercial Land / Plot", "Factory", "Showroom",
];

const generateSlug = (property) => {
  const base = `${property?.propertySubType} for ${property?.purpose} in ${property?.city}`;
  return base.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
};
export const SALE_PRICES = [
  { key: "price", value: 1000000, label: "Under 10L" },
  { key: "price", value: 2000000, label: "Under 20L" },
  { key: "price", value: 5000000, label: "Under 50L" },
  { key: "price", value: 10000000, label: "Under 1Cr" },
  { key: "price", value: 20000000, label: "Under 2Cr" },
  { key: "price", value: 50000000, label: "Under 5Cr" }
];

export const RENT_PRICES = [
  { key: "price", value: 10000, label: "Under 10K" },
  { key: "price", value: 20000, label: "Under 20K" },
  { key: "price", value: 30000, label: "Under 30K" },
  { key: "price", value: 50000, label: "Under 50K" },
  { key: "price", value: 80000, label: "Under 80K" },
  { key: "price", value: 100000, label: "Under 1L" }
];
export default function FloatingChatBot() {

  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [filters, setFilters] = useState({});
  const [messages, setMessages] = useState([]);
  const [properties, setProperties] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  // NEW lead form states
  const [leadForm, setLeadForm] = useState({
    name: "",
    phone: "",
    email: ""
  });
  const [leadSubmitted, setLeadSubmitted] = useState(false);

  const chatEndRef = useRef(null);

  const { mutate: Chating } = useApiMutation(
    "POST",
    "/user/last/chat"
  );

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading, properties]);

  const resetChat = () => {
    setMessages([
      { sender: "bot", text: "Hi 👋 Welcome to Gharnmakaan!" },
      { sender: "bot", text: "What type of property are you looking for today?" }
    ]);
    setFilters({});
    setProperties([]);
    setStep(1);
    setHasSearched(false);
    setLeadForm({ name: "", phone: "", email: "" });
    setLeadSubmitted(false);
  };

  const toggleChat = () => {
    if (!open) resetChat();
    else setMessages([]);
    setOpen(!open);
  };

  const sendMessage = async (key, value, label) => {

    setMessages((prev) => [...prev, { sender: "user", text: label }]);

    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);

    setLoading(true);

    setTimeout(() => {

      setLoading(false);

      let nextStep = step + 1;

      if (step === 4) {
        const subType = value;
        const isResidential = newFilters.propertyType === "residential";
        const needsBHK = isResidential && !["Land / Plot", "Farmhouse"].includes(subType);
        if (!needsBHK) nextStep = 6;
      }

      if (nextStep <= 6) {

        setStep(nextStep);

        const botTextMap = {
          2: "Is this for Residential or Commercial use?",
          3: "Got it! Which city are you interested in?",
          4: "What kind of property would you like?",
          5: "Select your preferred BHK:",
          6: "Almost there! What is your budget range?"
        };

        setMessages((prev) => [...prev, { sender: "bot", text: botTextMap[nextStep] }]);

      } else {

        setHasSearched(true);

        Chating(
          { params: null, body: newFilters },
          {
            onSuccess: (res) => {

              const foundData = res?.data || [];

              setProperties(foundData);

              setMessages((prev) => [
                ...prev,
                {
                  sender: "bot",
                  text: foundData.length > 0
                    ? "I've found some amazing matches! ✨"
                    : "I couldn't find any exact matches."
                }
              ]);

            },
            onError: () => {
              setMessages((prev) => [
                ...prev,
                { sender: "bot", text: "Connection error. Please try again later!" }
              ]);
            }
          }
        );
      }

    }, 800);
  };

  // NEW lead submit
  const handleLeadSubmit = () => {

    if (!leadForm.name || !leadForm.phone || !leadForm.email) {

      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Please fill all fields so we can contact you." }
      ]);

      return;
    }

    const payload = {
      ...filters,
      ...leadForm
    };

    Chating(
      { params: null, body: payload },
      {
        onSuccess: () => {

          setLeadSubmitted(true);

          setMessages((prev) => [
            ...prev,
            { sender: "bot", text: "✅ Thanks! We'll notify you when a matching property becomes available." }
          ]);

        }
      }
    );
  };

  return (
    <>

 
<Zoom in={!open}>
  <Box
    sx={{
      position: "fixed",
      bottom: 35,
      right: 28,
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      gap: 1.5,
    }}
  >
    {/* AI Assistant label */}
    <Box
      sx={{
        px: 2,
        py: 1,
        borderRadius: "14px 14px 4px 14px",
        bgcolor: "#fff",
        boxShadow: "0 5px 25px rgba(30,64,175,0.15)",
        border: "1px solid #dbeafe",
      }}
    >
      <Typography fontSize={12} fontWeight={800} color="#172554">
        AI Assistant
      </Typography>
      <Typography fontSize={10} color="#64748b">
        Ask me anything ✨
      </Typography>
    </Box>

    {/* Robot avatar chatbot */}
    <IconButton
      onClick={toggleChat}
      aria-label="Open AI assistant"
      sx={{
        width: 50,
        height: 50,
        p: 0,
        overflow: "visible",
        position: "relative",
        border: "3px solid white",
        borderRadius: "50%",
        background: "linear-gradient(135deg, #dffaff, #60a5fa)",
        boxShadow: "0 8px 28px rgba(37,99,235,0.35)",
        transition: "all .25s ease",
        "&:hover": {
          transform: "scale(1.08) translateY(-3px)",
          boxShadow: "0 12px 32px rgba(37,99,235,0.5)",
        },
        "&::before": {
          content: '""',
          position: "absolute",
          inset: -6,
          borderRadius: "50%",
          border: "2px solid rgba(59,130,246,0.35)",
          animation: "aiPulse 2s infinite",
          pointerEvents: "none",
        },
        "@keyframes aiPulse": {
          "0%": { transform: "scale(.95)", opacity: 0.8 },
          "100%": { transform: "scale(1.3)", opacity: 0 },
        },
      }}
    >
      <Avatar
        src="/chatbot.jpg"
        alt="AI Robot Assistant"
        imgProps={{ draggable: false }}
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          bgcolor: "#b8efff",
          "& img": {
            objectFit: "cover",
            objectPosition: "68% center",
          },
        }}
      />

      {/* Online indicator */}
      <Box
        sx={{
          position: "absolute",
          bottom: 1,
          right: 0,
          width: 15,
          height: 15,
          borderRadius: "50%",
          bgcolor: "#22c55e",
          border: "3px solid white",
        }}
      />
    </IconButton>
  </Box>
</Zoom>


      <Fade in={open}>
        <Box
          sx={{
            position: "fixed",
            bottom: { xs: 0, sm: 30 },
            right: { xs: 0, sm: 30 },
            width: { xs: "100%", sm: 400 },
            height: { xs: "100%", sm: 500 },
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fdfdfd",
            borderRadius: { xs: 0, sm: 4 },
            boxShadow: "0px 15px 50px rgba(0,0,0,0.2)",
            overflow: "hidden",
            zIndex: 1001
          }}
        >

          <Box
            sx={{
              p: 2,
              background: "linear-gradient(135deg,#1e3c72,#2a5298)",
              color: "white",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Badge variant="dot" color="success">
                <Avatar sx={{ bgcolor: "white", color: "#1e3c72" }}>
                  <SmartToyIcon />
                </Avatar>
              </Badge>
              <Typography fontWeight="bold">Gharnmakaan AI</Typography>
            </Stack>

            <IconButton size="small" onClick={toggleChat} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ flex: 1, overflowY: "auto", p: 2, display: "flex", flexDirection: "column", gap: 2 }}>

            {messages.map((m, i) => (
              <Box key={i} sx={{ alignSelf: m.sender === "user" ? "flex-end" : "flex-start", maxWidth: "85%" }}>
                <Paper
                  sx={{
                    p: 1.5,
                    borderRadius: m.sender === "user"
                      ? "18px 18px 2px 18px"
                      : "18px 18px 18px 2px",
                    bgcolor: m.sender === "user" ? "#1e3c72" : "white",
                    color: m.sender === "user" ? "white" : "#333",
                    border: m.sender === "bot" ? "1px solid #eee" : "none"
                  }}
                >
                  <Typography variant="body2">{m.text}</Typography>
                </Paper>
              </Box>
            ))}

           {!loading && (
  <Box sx={{ ml: 1 }}>
    
    {step === 1 && (
      <OptionGroup
        list={[
          { key: "purpose", value: "sale", label: "🏠 Buy" },
          { key: "purpose", value: "rent/lease", label: "🔑 Rent" },
          { key: "purpose", value: "PG", label: "🛌 PG" }
        ]}
        onSelect={sendMessage}
      />
    )}

    {step === 2 && (
      <OptionGroup
        list={[
          { key: "propertyType", value: "residential", label: "🏠 Residential" },
          { key: "propertyType", value: "commercial", label: "🏢 Commercial" }
        ]}
        onSelect={sendMessage}
      />
    )}

    {step === 3 && (
      <OptionGroup
        list={[
          "Noida",
          "Delhi",
          "Greater Noida",
          "Ghaziabad",
          "Mumbai",
          "Bangalore",
          "Gurgaon"
        ].map((c) => ({ key: "city", value: c, label: c }))}
        onSelect={sendMessage}
      />
    )}

    {step === 4 && (
      <OptionGroup
        list={(filters.propertyType === "commercial"
          ? COMMERCIAL_TYPES
          : RESIDENTIAL_TYPES
        ).map((s) => ({
          key: "propertySubType",
          value: s,
          label: s
        }))}
        onSelect={sendMessage}
      />
    )}

    {step === 5 && (
      <OptionGroup
        list={[
          { key: "bhk", value: "1BHK", label: "1 RK" },
          { key: "bhk", value: "2BHK", label: "2 BHK" },
          { key: "bhk", value: "3BHK", label: "3 BHK" },
          { key: "bhk", value: "4BHK", label: "4 BHK" },
          { key: "bhk", value: "5BHK", label: "5 BHK" },
          { key: "bhk", value: "6BHK", label: "6 BHK" }
        ]}
        onSelect={sendMessage}
      />
    )}
{step === 6 && (
  <OptionGroup
    list={
      filters.purpose === "sale" ? SALE_PRICES : RENT_PRICES
    }
    onSelect={sendMessage}
  />
)}

  </Box>
)}

            {/* PROPERTY RESULT */}
            {hasSearched && !loading && (
              properties.length > 0 ? (
                properties.map((p) => (
                  <CardActionArea
                    key={p.id}
                    sx={{ borderRadius: 3 }}
                    onClick={() =>
                      window.open(`/viewDetails/${generateSlug(p)}/${p.id}`, "_blank")
                    }
                  >
                    <Paper sx={{ p: 2, border: "1px solid #eee" }}>
                      <Stack direction="row" justifyContent="space-between">
                        <Typography fontWeight="bold" color="primary">
                          {p.propertySubType}
                        </Typography>
                        <Typography fontWeight="bold">₹{p.price}</Typography>
                      </Stack>
                      <Typography variant="caption">
                        {p.city} • {p.propertyType}
                      </Typography>
                    </Paper>
                  </CardActionArea>
                ))
              ) : (
                <Box sx={{ textAlign: 'center', py: 2 }}>

                  <SearchOffIcon sx={{ fontSize: 40, color: '#ccc' }} />

                  <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                    No properties found. Leave your details and we'll notify you.
                  </Typography>

                  {!leadSubmitted && (
                    <Stack spacing={1}>
                      <TextField
                        size="small"
                        placeholder="Your Name"
                        value={leadForm.name}
                        onChange={(e) =>
                          setLeadForm({ ...leadForm, name: e.target.value })
                        }
                      />

                      <TextField
                        size="small"
                        placeholder="Phone Number"
                        value={leadForm.phone}
                        onChange={(e) =>
                          setLeadForm({ ...leadForm, phone: e.target.value })
                        }
                      />

                      <TextField
                        size="small"
                        placeholder="Email Address"
                        value={leadForm.email}
                        onChange={(e) =>
                          setLeadForm({ ...leadForm, email: e.target.value })
                        }
                      />

                      <Button
                        variant="contained"
                        onClick={handleLeadSubmit}
                        sx={{ textTransform: "none" }}
                      >
                        Notify Me
                      </Button>
                    </Stack>
                  )}

                  <Button
                    startIcon={<ReplayIcon />}
                    size="small"
                    onClick={resetChat}
                    sx={{ textTransform: 'none', mt: 2 }}
                  >
                    Start Over
                  </Button>

                </Box>
              )
            )}

            <div ref={chatEndRef} />

          </Box>
        </Box>
      </Fade>
    </>
  );
}

const OptionGroup = ({ list, onSelect }) => (
  <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5, gap: 1 }}>
    {list.map((item) => (
      <Button
        key={item.label}
        variant="outlined"
        size="small"
        onClick={() => onSelect(item.key, item.value, item.label)}
        sx={{
          borderRadius: "8px",
          textTransform: "none",
          m: 0.3,
          borderColor: "#1e3c72",
          color: "#1e3c72",
          fontSize: '0.75rem',
          "&:hover": { bgcolor: "#1e3c72", color: "white" }
        }}
      >
        {item.label}
      </Button>
    ))}
  </Stack>
);